var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMan1Arm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "87px",
    viewBox: "0 0 47 87",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Man1Arm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man1Arm",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.77652314,86.8188803 L2.77652314,86.8188803 C0.823036241,86.1907334 -0.378127399,84.1076732 0.1080345,82.1899664 L1.79437789,75.5239781 C2.27955765,73.6092065 4.27233036,72.5544677 6.22287082,73.1806577 L6.22385297,73.1806577 C8.17635772,73.8088046 9.37752136,75.8918647 8.89234161,77.81055 L7.20501607,84.4755599 C6.71983632,86.3913099 4.72804575,87.4460487 2.77652314,86.8188803",
    id: "Fill-88",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,12.9571425 C47,12.9571425 24.0090109,34.2470062 19.2201328,44.6011691 C14.8885693,53.9665184 9.97343261,77 9.97343261,77 L0,74.2426739 C0,74.2426739 2.35417548,41.9354551 7.02872493,33.1396943 C11.9547974,23.8719318 33.6822066,0 33.6822066,0 L47,12.9571425",
    id: "Fill-89",
    fill: "#34C8CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan1Arm);
export default __webpack_public_path__ + "static/media/Man1Arm.4ff79debae0cd8af79b6d268aad739a5.svg";
export { ForwardRef as ReactComponent };